import React from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
	0% {
		background-position: 120% 0;
	}
	100% {
		background-position: -120% 0;
	}
`;

const SkeletonCard = styled.div`
	position: relative;
	width: 100%;
	height: 90px;
	min-height: 90px;
	border-radius: 20px;
	overflow: hidden;
	isolation: isolate;
	background: #171c2a;
	box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);

	@media (min-width: 768px) {
		max-width: calc(50% - 7.5px);
		height: 120px;
		min-height: 120px;
	}

	@media (min-width: 1024px) {
		max-width: 100%;
		height: 331px;
		min-height: 331px;
	}

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		background: radial-gradient(
				ellipse 90% 70% at 0% 0%,
				rgba(82, 151, 255, 0.38) 0%,
				transparent 58%
			),
			radial-gradient(
				ellipse 85% 65% at 100% 0%,
				rgba(82, 151, 255, 0.28) 0%,
				transparent 55%
			),
			radial-gradient(
				ellipse 70% 55% at 100% 100%,
				rgba(140, 72, 210, 0.18) 0%,
				transparent 50%
			),
			linear-gradient(180deg, rgba(31, 37, 54, 0.95) 0%, rgba(18, 21, 31, 1) 100%);
		pointer-events: none;
		z-index: 0;
	}

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		background: linear-gradient(
			110deg,
			transparent 30%,
			rgba(255, 255, 255, 0.1) 50%,
			transparent 70%
		);
		background-size: 220% 100%;
		animation: ${shimmer} 1.8s ease-in-out infinite;
		pointer-events: none;
		z-index: 1;
	}

	@media (prefers-reduced-motion: reduce) {
		&::after {
			animation: none;
			opacity: 0.35;
		}
	}
`;

export const BettoPaymentMethodsSkeleton = ({ count = 8 }) =>
	Array.from({ length: count }, (_, index) => (
		<SkeletonCard
			key={`betto-payment-skeleton-${index}`}
			aria-hidden="true"
		/>
	));
